import { useState } from 'react';

interface InfoPanelProps {
  id: string;
  title: string;
  children: React.ReactNode;
}

export default function InfoPanel({ id, title, children }: InfoPanelProps) {
  const storageKey = `info_panel_dismissed_${id}`;
  const [dismissed, setDismissed] = useState(() => {
    return localStorage.getItem(storageKey) === 'true';
  });

  const handleDismiss = () => {
    localStorage.setItem(storageKey, 'true');
    setDismissed(true);
  };

  if (dismissed) {
    return null;
  }

  return (
    <div className="bg-primary-50 border border-primary-200 rounded-lg p-4 mb-6">
      <div className="flex justify-between items-start">
        <div className="flex-1">
          <h3 className="text-sm font-semibold text-primary-800 mb-1">{title}</h3>
          <div className="text-sm text-primary-700">{children}</div>
        </div>
        <button
          onClick={handleDismiss}
          className="ml-4 text-primary-400 hover:text-primary-600 text-lg leading-none"
          title="Dismiss"
        >
          ×
        </button>
      </div>
    </div>
  );
}
